/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var QuoteBillPaymentStatusEnum;

(function (QuoteBillPaymentStatusEnum) {
  QuoteBillPaymentStatusEnum["PENDING"] = "pending";
  QuoteBillPaymentStatusEnum["SUCCEEDED"] = "succeeded";
  QuoteBillPaymentStatusEnum["FAILED"] = "failed";
  QuoteBillPaymentStatusEnum["CANCELED"] = "canceled";
  QuoteBillPaymentStatusEnum["NO_NEED_PAY"] = "no_need_pay";
})(QuoteBillPaymentStatusEnum || (QuoteBillPaymentStatusEnum = {}));